let controllerChangeListenerAdded = false;

const VersionHandlerModule = {
  state: {
    registration: null,
    update: {
      exists: false,
    },
  },
  mutations: {
    SET_SW_UPDATE_AVAILABLE: (state, registration) => {
      state.registration = registration;
      state.update.exists = true;
    },
    CLEAR_SW_UPDATE: (state) => {
      state.registration = null;
      state.update.exists = false;
    },
  },
  getters: {
    currentVersion: () => () => process.env.APP_VERSION.trim(),
    existsNewVersion: ({ update }) => update.exists,
  },
  actions: {
    APPLY_SW_UPDATE: ({ state, commit }) => {
      const { registration } = state;
      
      if (!registration || !registration.waiting) {
        window.location.reload();
        return;
      }

      if (!controllerChangeListenerAdded && 'serviceWorker' in navigator) {
        controllerChangeListenerAdded = true;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          window.location.reload();
        });
      }

      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      commit('CLEAR_SW_UPDATE');
    },
  },
};

export default VersionHandlerModule;
